import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { computed } from '@ember/object';
import { OrderTickets as OrderTicketsProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/common/order_tickets';
import Enum from '@square/dashboard-utilities/utils/enum';
export const OrderTicketNamingType = new Enum(Object.keys(OrderTicketsProto.OrderTicketNamingType));
export default ProtoBaseModel.extend({
  namingType: attr(OrderTicketNamingType),
  isAutoTicketNumbering: computed('namingType', function () {
    return this.namingType === OrderTicketNamingType.AUTOMATIC_NUMBERING || this.namingType === OrderTicketNamingType.AUTOMATIC_NUMBERING_INCLUDE_OPEN_TICKETS;
  }),
  isManualTicketNumbering: computed('namingType', function () {
    return this.namingType === OrderTicketNamingType.CUSTOM_NAME || this.namingType === OrderTicketNamingType.ALWAYS_PROMPT_FOR_CUSTOM_NAME;
  }),
  displayValueTranslationKey: computed('namingType', function () {
    if (this.namingType === OrderTicketNamingType.AUTOMATIC_NUMBERING || this.namingType === OrderTicketNamingType.AUTOMATIC_NUMBERING_INCLUDE_OPEN_TICKETS) {
      return 'business.devices.profiles.v2.settings.checkout.orderTickets.namingType.displayValue.auto';
    } else if (this.namingType === OrderTicketNamingType.NO_TICKET_IDENTIFIER) {
      return null;
    } else {
      return 'business.devices.profiles.v2.settings.checkout.orderTickets.namingType.displayValue.manual';
    }
  })
});